import React from 'react';

import PropertyCardContent from 'bundles/crm/properties/card/content';
import Thumbnail from 'bundles/crm/properties/thumbnail';
import { convertToEdgeCrmProperty } from 'bundles/research/index/helpers';

import type { Props } from './types';
import type { Property } from 'bundles/research/index/properties/types';

export default function EdgeCrmMapListItem({
  googleMapsApiKey,
  isSelected,
  record,
  onClick,
  onSelectionToggle,
  ...props
}: Props) {
  return (
    <div className="d-flex ds-bg-light ds-border ds-rounded m-4 py-3 px-2" {...props}>
      <div className="map-list__checkbox pl-0 h-100">
        <input
          checked={isSelected}
          className="checkbox--lg"
          type="checkbox"
          onChange={onSelectionToggle}
        />
      </div>

      <div className="flex-1">
        <PropertyCardContent property={convertToEdgeCrmProperty(record as Property)} onClick={onClick} />
      </div>

      <Thumbnail
        googleMapsApiKey={googleMapsApiKey}
        height={63}
        property={record as Property}
        width={112}
      />
    </div>
  );
}
